var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNgGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1868 7.18683C19.6359 7.63594 19.6359 8.36408 19.1868 8.81318L8.18683 19.8131C7.73773 20.2622 7.00959 20.2622 6.56049 19.8131C6.11138 19.364 6.11139 18.6358 6.56049 18.1867L17.5605 7.18682C18.0096 6.73772 18.7377 6.73773 19.1868 7.18683Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81317 7.18683C6.36407 7.63594 6.36407 8.36408 6.81318 8.81318L17.8132 19.8131C18.2623 20.2622 18.9904 20.2622 19.4395 19.8131C19.8886 19.364 19.8886 18.6358 19.4395 18.1867L8.43951 7.18682C7.99041 6.73772 7.26227 6.73773 6.81317 7.18683Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgGray);
export default __webpack_public_path__ + "static/media/icon_ng_gray.fa3b09d13c29cb6d3f1832792632353a.svg";
export { ForwardRef as ReactComponent };